export default {
  created() {
    this.opts = {
      headers: {},
      withCredentials: true,
    };
  },
  mounted() {
    this.setLocale(
      localStorage.getItem("lang") ? localStorage.getItem("lang") : false,
    );
  },
  methods: {
    setLocale(value) {
      const locale = value || "en";
      // vue-i18n (legacy mode)
      if (this.$i18n) this.$i18n.locale = locale;
      // Vuetify 3
      if (this.$vuetify?.locale?.current !== undefined) {
        this.$vuetify.locale.current = locale; // se non usi l'adapter
      }
    },
    setExpiredSession() {
      document.dispatchEvent(
        new CustomEvent("session-expired", {
          detail: {
            storage: true,
          },
        }),
      );
    },
  },
};
